import { graphql } from "../gql";

export default graphql(`
  query getLiveCoreOddsQuery($input: OddsMarketTypesInput!) {
    event(input: $input) {
      odds {
        moneyline {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
        spread {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
        totalPoints {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
          teamNumberFireId
        }
      }
    }
  }
`);
